<template>
    <section class="why-meshare-part">
        <div class="box-word">
            <p class="title">Why meShare</p>
            <ul class="list">
                <li>
                    <div class="box-icon">
                        <img class="w-ic0" src="/static/svg/AI-Powered & Efficient Platform.svg">
                    </div>
                    <div class="box-text">
                        <p class="word1">AI-Powered & Efficient Platform</p>
                        <p class="word2">
                            Optimized architecture to handle video-streaming and IoT solutions, elastic load-balancing and real-time monitoring to ensure resource efficiency. Allows for higher cost-savings, competitive product offerings, and more.
                        </p>
                    </div>
                </li>

                <li>
                    <div class="box-icon">
                        <img class="w-ic0" src="/static/svg/Growth and Scalability.svg">
                    </div>
                    <div class="box-text">
                        <p class="word1">Growth and Scalability</p>
                        <p class="word2">
                            Growing list of products, features, and services to help you scale and grow your business. Manage with analytics and marketing tools, utilize expert services, and SaaS model deployment to maximize potential revenue streams.
                        </p>
                    </div>
                </li>
                <li>
                    <div class="box-icon">
                        <img class="w-ic0" src="/static/svg/Short Implementation and Fast Deployment.svg">
                    </div>
                    <div class="box-text">
                        <p class="word1">Short Implementation and Fast Deployment</p>
                        <p class="word2">
                            Partner with our team of experts and developers to build and launch your market-ready solutions in record time, creating experiences unique to your brand.
                        </p>
                    </div>
                </li>
                <li>
                    <div class="box-icon">
                        <img class="w-ic0" src="/static/svg/Market-Tested Solutions.svg">
                    </div>
                    <div class="box-text">
                        <p class="word1">Market-Tested Solutions</p>
                        <p class="word2">
                            Offers products and services that have been tested and used by successful businesses. You'll have confidence knowing that you are launching trusted solutions with experts that understand your field.
                        </p>
                    </div>
                </li>
                <li>
                    <div class="box-icon">
                        <img class="w-ic0" src="/static/svg/Mission-Critical Reliability.svg">
                    </div>
                    <div class="box-text">
                        <p class="word1">Mission-Critical Reliability</p>
                        <p class="word2">
                            meShare's US-based data centers have featured 99.99% uptime, with industry leading bandwidth capability.
                        </p>
                    </div>
                </li>
                <li>
                    <div class="box-icon">
                        <img class="w-ic0" src="/static/svg/Bank-Level Security and Encryption.svg">
                    </div>
                    <div class="box-text">
                        <p class="word1">Bank-Level Security and Encryption</p>
                        <p class="word2">
                            meShare's platform, cloud hosting and data transfer are all protected by 256-bit AES bank-level encryption, and our US-based data centers are all secured for reliability and redundancy.
                        </p>
                    </div>
                </li>
            </ul>
            <div class="box-btn" v-if="false">
                <a href="" class="btn"><span>Explore Advantage</span></a>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'why-meshare-common'
}
</script>
<style lang="scss" scope>
@import '@/assets/css/common.scss';
.why-meshare-part{
    background: #ba0c2f;
    padding: 40px 0 !important;
    @media screen and (max-width:$media-max-width){
        padding: 50px 0 !important;
    }
    .box-word{
        width: 96%;
        max-width: 1280px;
        margin: 0 auto;
        color: #ffffff;
        @media screen and (max-width:$media-max-width){
            width: 90%;
        }
        .title{
        font-size: 28px;
        font-family: 'GothamMedium';
        text-align: center;
        margin-bottom: 40px;
        @media screen and (max-width:$media-max-width){
            font-size: 25px;
            margin-bottom: 30px;
        }
        }
        .list{
            color: #ffffff;
            display: -webkit-flex;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            flex-wrap: wrap;
            li{
                display: -webkit-flex;
                display: flex;
                justify-content: center;
                flex-direction: row;
                width: 45%;
                margin-right: 25px;
                margin-bottom: 25px;
                @media screen and (max-width:1280px){
                    width: 50%;
                }
                @media screen and (max-width:$media-max-width){
                    width: 100%;
                    margin-bottom: 30px;
                }
                @media screen and (max-width: 500px){
                    margin-bottom: 10px;
                }
            }
            .box-icon{
                fill: #ffffff;
                width: 55px;
                height: 55px;
                text-align: center;
                @media screen and (max-width:$media-max-width){
                    width: 35px;
                    height: 35px;
                }
                img{
                    @media screen and (max-width:$media-max-width){
                        // width: 100%;
                        transform: scale(.9);
                    }
                    @media screen and (max-width: 500px){
                        // width: 100%;
                        transform: scale(.8);
                    }
                }
            }
            .box-text{
                display: -webkit-flex;
                display: flex;
                justify-content: start;
                flex-direction: column;
                width: calc(100% - 100px);
                box-sizing: border-box;
                padding: 0 10px;
                @media screen and (max-width:$media-max-width){
                    width: calc(100% - 50px);
                    padding: 0 0 0 20px;
                }
                @media screen and (max-width: 500px){
                    padding: 0 0 0 10px;
                }
            }
            .word1{
                font-size: 20px;
                font-family: 'GothamBook';
                margin-bottom: 10px;
                font-weight: bold;
                @media screen and (max-width:$media-max-width){
                    font-size: 18px;
                }
            }
            .word2{
                font-size: 14px;
                font-family: 'GothamLight';
                width: 100%;
                line-height: 16px;
                @media screen and (max-width:$media-max-width){
                    font-size: 12px;
                    width: 100%;
                    line-height: 16px;
                }
            }
        }
        .box-btn{
            @media screen and (max-width:$media-max-width){
                margin-top: 30px;
            }
            .btn{
                margin: 0 auto;
                width: 210px;
                height: 38px;
                display: -webkit-flex;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                color: #ba0c2f;
                background: #ffffff;
                border-radius: 30px;
                text-decoration: unset;
                font-family: 'GothamLight';
                transition: all .7s;
                text-transform: uppercase;
                @media screen and (max-width:$media-max-width){
                    width: 90%;
                    max-width: 340px;
                    font-size: 12px;
                    height: 39px;
                }
                &:hover{
                    background: #999999;
                    color: #ffffff;
                }
                span{
                    @media screen and (max-width: 400px){
                        transform: scale(.85);
                        white-space: nowrap;
                    }
                }
            }
        }
    }
    .w-ic0{
        width: 44px;
    }
    .w-ic1{
        width: 43px;
    }
    .w-ic2{
        width: 44px;
    }
    .w-ic3{
        width: 38px;
    }
    .w-ic4{
        width: 36px;
    }
    .w-ic5{
        width: 33px;
    }
    .w-ic6{
        width: 34px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/common/why-meshare.vue